export class TransactionNames { 
    static WebAppDummyTransaction: string = "WebAppDummyTransaction";
    static WebRoute: string = "WebRoute";
    static LoginFormTransaction: string = "LoginFormTransaction";
    static InnerMenuTransaction: string = "InnerMenuTransaction";  
}
